import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { useSharedAppLists } from '../../../hooks/useSharedAppLists';
import SharedAppList from '../../SharedApp/SharedAppList';

interface SharedAppListSelectorModalProps {
  title: string;
  fieldName: string;
  listType?: string;
  onClose: () => void;
  currentValue: string[];
  onSave: (fieldName: string, value: string[]) => void;
}

function SharedAppListSelectorModal({ 
  title, 
  fieldName, 
  listType, 
  onClose,
  currentValue,
  onSave
}: SharedAppListSelectorModalProps) {
  const [selectedLists, setSelectedLists] = useState<number[]>([]);
  
  const { data: sharedAppData, isLoading } = useSharedAppLists('', 1, 100, {});

  useEffect(() => {
    setSelectedLists(currentValue.map(id => parseInt(id, 10)).filter(id => !Number.isNaN(id)));
  }, [currentValue]);

  const handleSelectionChange = (id: number, selected: boolean) => {
    setSelectedLists(prev => {
      if (selected) {
        return [...prev, id];
      } 
      return prev.filter(listId => listId !== id);
    });
  };

  const handleSave = () => {
    onSave(fieldName, selectedLists.map(id => id.toString()));
    onClose();
  };

  return (
    <Dialog open maxWidth="lg" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography>
            Select shared app lists to associate with this ad group.
            {/* eslint-disable-next-line no-nested-ternary */}
            {isLoading ? ' (Loading...)' : 
             sharedAppData?.collection ? 
             ` (${sharedAppData.collection.length} lists available, filtering by type: ${listType || 'none'})` : 
             ' (No data available)'}
          </Typography>
          
          <SharedAppList 
            selectable
            selectedIds={selectedLists}
            onSelectionChange={handleSelectionChange}
            listTypeFilter={listType}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
}

export default SharedAppListSelectorModal; 